/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkconnect2Inputs */

const en_profilelinkconnect2 = /** @type {(inputs: Profilelinkconnect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect`)
};

const de_profilelinkconnect2 = /** @type {(inputs: Profilelinkconnect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinden`)
};

/**
* | output |
* | --- |
* | "Connect" |
*
* @param {Profilelinkconnect2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkconnect2 = /** @type {((inputs?: Profilelinkconnect2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkconnect2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkconnect2(inputs)
	return de_profilelinkconnect2(inputs)
});
export { profilelinkconnect2 as "profileLinkConnect" }